<template>
    <b-form-group
        :label="field.label"
        :label-for="`id_${field._id}`"
        :class="{
            'required-field': field.isRequired,
        }"
    >
        <multiselect
            v-model="model"
            v-validate="{
                required: true,
            }"
            :disabled="loading"
            :placeholder="field.placeholder"
            :options="formatOptions"
            :label="textField"
            :track-by="valueField"
            :multiple="multiple"
            :taggable="false"
            :data-vv-name="field.label"
            :class="[
                {
                    'is-invalid': errors.has(field.label),
                },
            ]"
            :show-no-results="false"
        ></multiselect>
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'

import List from './List.vue'
import Multiselect from 'vue-multiselect'

export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Multiselect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: 'productId',
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),

        /**
         * format the products list as required
         *
         * @return {void}
         */
        formatOptions() {
            return this.options.map((option) => {
                return {
                    productId: option._id,
                    title: option.title,
                    number: '',
                }
            })
        }, // End of formatOptions() method
    }, // End of Component > computed
}
</script>
